import { gql } from "../gql";

export const LOGIN_MUTATION = gql(`
  mutation Login($input: LoginInput!) {
    login(input: $input) {
      accessToken
      refreshToken
      user {
        id
        email
        firstName
        lastName
        role
        isActive
        emailVerified
        preferredLanguage
        createdAt
        updatedAt
      }
    }
  }
`);

export const ME_QUERY = gql(`
  query Me {
    me {
      id
      email
      firstName
      lastName
      role
      isActive
      emailVerified
      preferredLanguage
      createdAt
      updatedAt
    }
  }
`);

export const GET_USER_FRANCHISES_QUERY = gql(`
  query GetUserFranchises {
    getUserFranchises {
      id
      role
      isActive
      userId
      franchiseId
      createdAt
      franchise {
        id
        name
        slug
        description
        logoUrl
        isActive
        createdAt
        updatedAt
        salons {
          id
          name
          address
          city
          state
          country
          latitude
          longitude
          placeId
          currency
          timezone
          defaultLanguage
          franchiseId
          isActive
          role
          createdAt
          updatedAt
          contactInfo {
            id
            type
            value
            label
            order
          }
        }
      }
    }
  }
`);

export const UPDATE_USER_SALON_ROLE_MUTATION = gql(`
  mutation UpdateUserSalonRole($input: UpdateUserSalonRoleInput!) {
    updateUserSalonRole(input: $input) {
      id
      salonId
      role
      isActive
      createdAt
      salon {
        id
        name
        franchise {
          id
          name
        }
      }
      worker {
        id
        userId
        displayName
        user {
          id
          email
          firstName
          lastName
        }
      }
    }
  }
`);

export const CHANGE_PASSWORD_MUTATION = gql(`
  mutation ChangePassword($input: ChangePasswordInput!) {
    changePassword(input: $input)
  }
`);

export const REQUEST_PASSWORD_RESET_MUTATION = gql(`
  mutation RequestPasswordReset($input: RequestPasswordResetInput!) {
    requestPasswordReset(input: $input) {
      success
      message
    }
  }
`);

export const VALIDATE_RESET_TOKEN_QUERY = gql(`
  query ValidateResetToken($input: ValidateResetTokenInput!) {
    validateResetToken(input: $input) {
      valid
      message
    }
  }
`);

export const RESET_PASSWORD_WITH_TOKEN_MUTATION = gql(`
  mutation ResetPasswordWithToken($input: ResetPasswordWithTokenInput!) {
    resetPasswordWithToken(input: $input)
  }
`);

export const EXCHANGE_AUTH_HANDOFF_CODE_MUTATION = gql(`
  mutation ExchangeAuthHandoffCode($input: ExchangeAuthHandoffCodeInput!) {
    exchangeAuthHandoffCode(input: $input) {
      accessToken
      refreshToken
      user {
        id
        email
        firstName
        lastName
        role
        isActive
        emailVerified
        preferredLanguage
        createdAt
        updatedAt
      }
    }
  }
`);

export const REFRESH_TOKEN_MUTATION = gql(`
  mutation RefreshToken($input: RefreshTokenInput!) {
    refreshToken(input: $input) {
      accessToken
      refreshToken
    }
  }
`);

export const ISSUE_REFRESH_TOKEN_MUTATION = gql(`
  mutation IssueRefreshToken {
    issueRefreshToken
  }
`);
